import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../Containers/Config/index.js';
import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_REASON, UPDATE_REASON_SUCCESS, UPDATE_REASON_ERROR } from '../../actions.js';
// import apiCall from '../../apiCall';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateReason({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/remarks/${payload?.id}`,
      method: 'PUT',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: UPDATE_REASON_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_REASON_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_REASON_ERROR, payload: error });
  }
}

export function* watchupdateReason() {
  yield takeEvery(UPDATE_REASON, updateReason);
}

function* updateReasonSaga() {
  yield all([fork(watchupdateReason)]);
}

export default updateReasonSaga;
